<template>
  <b-nav-item @click="skin = isDark ? 'light' : 'dark'">
    <feather-icon
      size="21"
      :icon="`${isDark ? 'Sun' : 'Moon'}Icon`"
      @click="Save()"
    />
  </b-nav-item>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { computed } from '@vue/composition-api'
import { BNavItem } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BNavItem,
  },
  setup() {
    const { skin } = useAppConfig()

    const isDark = computed(() => skin.value === 'dark')

    return { skin, isDark }
  },
  methods: {
    Save() {
      let newSkin = this.isDark ? "light" : "dark";
       this.$http.post('/api/user/update/frontend', JSON.stringify({
        Skin: newSkin
      }))
          .then(resp => {
            if (resp.data.success) {

            }
          })
          .catch(err => {
            this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Fehler',
                    icon: 'CheckIcon',
                    text: 'Es ist ein Fehler aufgetreten',
                    variant: 'danger',
                  },
                },
                {
                  timeout: 5000,
                })
          })

      console.log(this.skin)
    }
  }
}
</script>
